var _rect, _circle, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCornerLowerLeftRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 80,
    viewBox: "0 0 106 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    width: 80,
    height: 106,
    rx: 4,
    transform: "rotate(90 106 0)",
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.666,
    cy: 40.1123,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5113 51.999H63.9113V38.199C63.9113 34.799 63.9113 27.399 53.6613 27.399C49.8613 27.399 46.1113 28.549 43.4613 31.249L46.6113 34.399C48.2113 32.899 50.5113 31.899 53.0113 31.899C56.2113 31.899 58.5113 33.449 58.5113 36.399V37.049H57.0113C51.0113 37.049 41.9113 37.599 41.9113 45.399C41.9113 50.149 46.2113 52.599 50.6613 52.599C53.8613 52.599 56.6613 51.399 58.3613 48.699H58.5113V51.999ZM58.1613 42.599C58.1613 45.949 56.2113 48.099 52.1113 48.099C50.1613 48.099 47.9113 47.149 47.9113 44.949C47.9113 41.499 53.6113 41.249 56.9113 41.249H58.1613V42.599Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.33203,
    y: 52.4443,
    width: 2.5,
    height: 14,
    rx: 1.25,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCornerLowerLeftRight);
export default __webpack_public_path__ + "static/media/jobconfig-binding-corner-lowerLeft-right.205344f3e75c77b3150ee086fd432812.svg";
export { ForwardRef as ReactComponent };